import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import searchParamString from '@/utils/schema/searchParamString'

export interface RestaurantId {
  restaurant_id: string
}

const DEFAULT_VALUES = {
  restaurantId: '',
  search: '',
}

const indexSearchSchema = type({
  restaurantId: searchParamString.default(DEFAULT_VALUES.restaurantId),
  search: searchParamString.default(DEFAULT_VALUES.search),
})

export const Route = createFileRoute('/_food-grubhub/restaurant/$restaurantId/')({
  validateSearch: indexSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
})
